import React, { useState, useContext } from 'react';
import { ShippingBanner } from '../components/ShippingBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PaymentMethod } from '../components/checkout/PaymentMethod';
import { Button } from '../components/ui/Button';
import { NavigationContext, CartContext } from '../App';
import { ChevronLeft, User, MapPin, CreditCard, ShoppingBag } from 'lucide-react';
export function CheckoutPage() {
  const {
    navigate
  } = useContext(NavigationContext);
  const {
    cart,
    cartTotal,
    cartCount
  } = useContext(CartContext);
  const [paymentMethod, setPaymentMethod] = useState<'zelle' | 'cashapp' | null>(null);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'United States'
  });
  const subtotal = cartTotal;
  const shipping = subtotal >= 75 ? 0 : 8.95;
  const tax = subtotal * 0.0825;
  const total = subtotal + shipping + tax;
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!paymentMethod) {
      alert('Please select a payment method');
      return;
    }
    navigate('confirmation');
  };
  const inputStyles = `w-full px-3 sm:px-4 py-3 bg-white border border-[#E8E8E8] text-[#1A1A1A] text-sm font-['Raleway'] focus:outline-none focus:border-[#D4A853] focus:ring-1 focus:ring-[#D4A853]/20 transition-all duration-200 placeholder-[#6B6B6B]`;
  const labelStyles = 'block text-xs font-medium text-[#6B6B6B] uppercase tracking-[0.12em] mb-2';
  const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
  // Redirect to cart if empty
  if (cart.length === 0) {
    return <div className="min-h-screen flex flex-col bg-[#FAFAFA]" data-id="element-644">
        <ShippingBanner data-id="element-645" />
        <Navbar data-id="element-646" />
        <main className="flex-grow py-12 lg:py-20" data-id="element-647">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center" data-id="element-648">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#F5F5F5] flex items-center justify-center" data-id="element-649">
              <ShoppingBag size={32} className="text-[#6B6B6B]" strokeWidth={1.5} data-id="element-650" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-['Playfair_Display'] text-[#1A1A1A] mb-3" data-id="element-651">
              Your Cart is Empty
            </h1>
            <p className="text-sm sm:text-base text-[#6B6B6B] font-['Raleway'] mb-8" data-id="element-652">
              Add some items to your cart before checking out.
            </p>
            <Button onClick={() => navigate('shop')} variant="secondary" data-id="element-653">
              Start Shopping
            </Button>
          </div>
        </main>
        <Footer data-id="element-654" />
      </div>;
  }
  return <div className="min-h-screen flex flex-col bg-[#FAFAFA]" data-id="element-655">
      <ShippingBanner data-id="element-656" />
      <Navbar data-id="element-657" />

      <main className="flex-grow py-4 sm:py-6 lg:py-10" data-id="element-658">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-659">
          <button onClick={() => navigate('cart')} className="inline-flex items-center gap-1 text-xs text-[#6B6B6B] hover:text-[#1A1A1A] transition-colors mb-6 sm:mb-8 uppercase tracking-wider" data-id="element-660">
            <ChevronLeft size={14} data-id="element-661" /> Back to Cart
          </button>

          <div className="mb-6 sm:mb-10" data-id="element-662">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-663">
              Checkout
            </h1>
            <div className="w-10 h-[2px] bg-[#D4A853] mt-3" data-id="element-664" />
          </div>

          <form onSubmit={handleSubmit} data-id="element-665">
            <div className="flex flex-col lg:grid lg:grid-cols-12 gap-6 lg:gap-10" data-id="element-666">
              {/* Order Summary - Mobile (shows first) */}
              <div className="lg:hidden" data-id="element-667">
                <div className="bg-white border border-[#E8E8E8] p-4" data-id="element-668">
                  <div className="flex justify-between items-center mb-3" data-id="element-669">
                    <h2 className="text-base font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-670">
                      Order Summary
                    </h2>
                    <button type="button" onClick={() => navigate('cart')} className="text-xs text-[#D4A853] hover:text-[#B8923F] font-['Raleway']" data-id="element-671">
                      Edit Cart
                    </button>
                  </div>
                  <p className="text-sm text-[#6B6B6B] font-['Raleway'] mb-3" data-id="element-672">
                    {cartCount} {cartCount === 1 ? 'item' : 'items'}
                  </p>
                  <div className="flex justify-between text-sm font-['Raleway']" data-id="element-673">
                    <span className="text-[#6B6B6B]" data-id="element-674">Total</span>
                    <span className="font-bold text-[#D4A853]" data-id="element-675">
                      ${total.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Form */}
              <div className="lg:col-span-7 space-y-4 sm:space-y-6" data-id="element-676">
                {/* Contact Information */}
                <section className="bg-white p-4 sm:p-5 lg:p-6 border border-[#E8E8E8]" data-id="element-677">
                  <div className="flex items-center gap-3 mb-4 sm:mb-5" data-id="element-678">
                    <div className="w-8 h-8 rounded-full bg-[#D4A853]/10 flex items-center justify-center flex-shrink-0" data-id="element-679">
                      <User size={14} className="text-[#D4A853]" strokeWidth={1.5} data-id="element-680" />
                    </div>
                    <h2 className="text-base sm:text-lg font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-681">
                      Contact Information
                    </h2>
                  </div>
                  <div className="space-y-3 sm:space-y-4" data-id="element-682">
                    <div data-id="element-683">
                      <label htmlFor="fullName" className={labelStyles} data-id="element-684">
                        Full Name
                      </label>
                      <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleInputChange} placeholder="Jane Doe" required className={inputStyles} data-id="element-685" />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" data-id="element-686">
                      <div data-id="element-687">
                        <label htmlFor="email" className={labelStyles} data-id="element-688">
                          Email
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="jane@example.com" required className={inputStyles} data-id="element-689" />
                      </div>
                      <div data-id="element-690">
                        <label htmlFor="phone" className={labelStyles} data-id="element-691">
                          Phone
                        </label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="(555) 123-4567" required className={inputStyles} data-id="element-692" />
                      </div>
                    </div>
                  </div>
                </section>

                {/* Shipping Address */}
                <section className="bg-white p-4 sm:p-5 lg:p-6 border border-[#E8E8E8]" data-id="element-693">
                  <div className="flex items-center gap-3 mb-4 sm:mb-5" data-id="element-694">
                    <div className="w-8 h-8 rounded-full bg-[#D4A853]/10 flex items-center justify-center flex-shrink-0" data-id="element-695">
                      <MapPin size={14} className="text-[#D4A853]" strokeWidth={1.5} data-id="element-696" />
                    </div>
                    <h2 className="text-base sm:text-lg font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-697">
                      Shipping Address
                    </h2>
                  </div>
                  <div className="space-y-3 sm:space-y-4" data-id="element-698">
                    <div data-id="element-699">
                      <label htmlFor="address" className={labelStyles} data-id="element-700">
                        Street Address
                      </label>
                      <input type="text" id="address" name="address" value={formData.address} onChange={handleInputChange} placeholder="123 Main Street, Apt 4B" required className={inputStyles} data-id="element-701" />
                    </div>
                    <div className="grid grid-cols-2 gap-3 sm:gap-4" data-id="element-702">
                      <div className="col-span-2 sm:col-span-1" data-id="element-703">
                        <label htmlFor="city" className={labelStyles} data-id="element-704">
                          City
                        </label>
                        <input type="text" id="city" name="city" value={formData.city} onChange={handleInputChange} placeholder="Los Angeles" required className={inputStyles} data-id="element-705" />
                      </div>
                      <div data-id="element-706">
                        <label htmlFor="state" className={labelStyles} data-id="element-707">
                          State
                        </label>
                        <select id="state" name="state" value={formData.state} onChange={handleInputChange} required className={`${inputStyles} cursor-pointer`} data-id="element-708">
                          <option value="" data-id="element-709">--</option>
                          {states.map(s => <option key={s} value={s} data-id="element-710">
                              {s}
                            </option>)}
                        </select>
                      </div>
                      <div data-id="element-711">
                        <label htmlFor="zipCode" className={labelStyles} data-id="element-712">
                          Zip Code
                        </label>
                        <input type="text" id="zipCode" name="zipCode" value={formData.zipCode} onChange={handleInputChange} placeholder="90210" required className={inputStyles} data-id="element-713" />
                      </div>
                    </div>
                    <div data-id="element-714">
                      <label htmlFor="country" className={labelStyles} data-id="element-715">
                        Country
                      </label>
                      <input type="text" id="country" name="country" value={formData.country} disabled className={`${inputStyles} bg-[#F5F5F5] text-[#6B6B6B] cursor-not-allowed`} data-id="element-716" />
                    </div>
                  </div>
                </section>

                {/* Payment Method */}
                <section className="bg-white p-4 sm:p-5 lg:p-6 border border-[#E8E8E8]" data-id="element-717">
                  <div className="flex items-center gap-3 mb-4 sm:mb-5" data-id="element-718">
                    <div className="w-8 h-8 rounded-full bg-[#D4A853]/10 flex items-center justify-center flex-shrink-0" data-id="element-719">
                      <CreditCard size={14} className="text-[#D4A853]" strokeWidth={1.5} data-id="element-720" />
                    </div>
                    <h2 className="text-base sm:text-lg font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-721">
                      Payment Method
                    </h2>
                  </div>
                  <PaymentMethod selectedMethod={paymentMethod} onSelect={setPaymentMethod} data-id="element-722" />
                </section>

                <Button type="submit" size="lg" variant="secondary" className="w-full h-12 sm:h-[52px] text-xs tracking-[0.2em] font-semibold" data-id="element-723">
                  Place Order · ${total.toFixed(2)}
                </Button>

                <p className="text-[10px] sm:text-xs text-center text-[#6B6B6B] font-['Raleway']" data-id="element-724">
                  By placing your order, you agree to our Terms of Service and
                  Privacy Policy.
                </p>
              </div>

              {/* Order Summary - Desktop */}
              <div className="hidden lg:block lg:col-span-5" data-id="element-725">
                <div className="bg-white border border-[#E8E8E8] p-5 sm:p-6 sticky top-24" data-id="element-726">
                  <div className="flex justify-between items-center mb-5" data-id="element-727">
                    <h2 className="text-lg font-['Playfair_Display'] text-[#1A1A1A]" data-id="element-728">
                      Order Summary
                    </h2>
                    <button type="button" onClick={() => navigate('cart')} className="text-xs text-[#D4A853] hover:text-[#B8923F] font-['Raleway'] transition-colors" data-id="element-729">
                      Edit Cart
                    </button>
                  </div>

                  {/* Cart Items Preview */}
                  <div className="space-y-3 mb-5 pb-5 border-b border-[#E8E8E8] max-h-[300px] overflow-y-auto" data-id="element-730">
                    {cart.map(item => <div key={`${item.id}-${item.size}-${item.color}`} className="flex gap-3" data-id="element-731">
                        <div className="w-14 h-16 bg-[#F5F5F5] flex-shrink-0 overflow-hidden" data-id="element-732">
                          {typeof item.image === 'string' && item.image.startsWith('http') ? <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-733" /> : <div className={`w-full h-full ${item.image}`} data-id="element-734" />}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-735">
                          <h3 className="text-sm font-medium text-[#1A1A1A] font-['Playfair_Display'] leading-snug truncate" data-id="element-736">
                            {item.name}
                          </h3>
                          <p className="text-[11px] text-[#6B6B6B] font-['Raleway']" data-id="element-737">
                            {item.size} · {item.color} · Qty {item.quantity}
                          </p>
                          <p className="text-sm font-medium text-[#1A1A1A] font-['Raleway'] mt-1" data-id="element-738">
                            ${(item.price * item.quantity).toFixed(2)}
                          </p>
                        </div>
                      </div>)}
                  </div>

                  {/* Totals */}
                  <div className="space-y-2 text-sm font-['Raleway']" data-id="element-739">
                    <div className="flex justify-between" data-id="element-740">
                      <span className="text-[#6B6B6B]" data-id="element-741">
                        Subtotal ({cartCount} items)
                      </span>
                      <span className="text-[#1A1A1A]" data-id="element-742">
                        ${subtotal.toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-743">
                      <span className="text-[#6B6B6B]" data-id="element-744">Shipping</span>
                      <span className={shipping === 0 ? 'text-green-600 font-medium' : 'text-[#1A1A1A]'} data-id="element-745">
                        {shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-746">
                      <span className="text-[#6B6B6B]" data-id="element-747">Tax</span>
                      <span className="text-[#1A1A1A]" data-id="element-748">${tax.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between pt-3 mt-2 border-t border-[#E8E8E8]" data-id="element-749">
                      <span className="font-semibold text-[#1A1A1A]" data-id="element-750">
                        Total
                      </span>
                      <span className="text-xl font-bold text-[#D4A853]" data-id="element-751">
                        ${total.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>

      <Footer data-id="element-752" />
    </div>;
}